/**
 * DIEUKYDIEU.TV - STORY ACTIONS, LIKES, SOCIAL & FONT RESIZING
 */
import { t } from '../i18n.js';
import { showToast } from '../ui.js';
import { checkIsLiked, getArticleLikes, openShareAction, openShareModalDesktop } from '../social.js';
import { navigateToView } from '../router.js';
import { findArticleData } from './story-content.js';

export let currentStoryArticle = null;
export function setCurrentStoryArticle(art) { currentStoryArticle = art; }
export { getArticleLikes };

let currentFontSizeLevel = 0;
export function setStoryFontSizeLevel(level) {
    currentFontSizeLevel = Math.max(-1, Math.min(2, level));
}
const FONT_SIZES = ['15px', '17px', '19px', '21px'];

export function updateAllStoryLikeButtons(artId) {
    const isLiked = checkIsLiked(artId);
    const count = getArticleLikes(artId);

    // 1. Top Like Button (Mobile Capsule)
    const topBtn = document.getElementById('story-top-like-btn');
    if (topBtn) {
        topBtn.classList.toggle('liked', isLiked);
        const icon = topBtn.querySelector('.material-symbols-rounded');
        const counter = topBtn.querySelector('.like-counter');
        if (icon) icon.innerText = isLiked ? 'favorite' : 'favorite_border';
        if (counter) counter.innerText = count;
    }

    // 1b. Desktop/Tablet Left Like Button
    const deskBtn = document.getElementById('story-desktop-like-btn');
    if (deskBtn) {
        deskBtn.classList.toggle('liked', isLiked);
        const icon = deskBtn.querySelector('.material-symbols-rounded');
        const counter = deskBtn.querySelector('.like-counter');
        if (icon) icon.innerText = isLiked ? 'favorite' : 'favorite_border';
        if (counter) counter.innerText = count;
    }

    // 2. Bottom Big Like Button
    const bottomBtn = document.getElementById('story-bottom-like-btn');
    if (bottomBtn) {
        bottomBtn.classList.toggle('liked', isLiked);
        const icon = bottomBtn.querySelector('.material-symbols-rounded');
        const counter = bottomBtn.querySelector('.like-counter');
        if (icon) icon.innerText = isLiked ? 'favorite' : 'favorite_border';
        if (counter) counter.innerText = count;
    }

    // 2b. Byline Likes Display
    const bylineLikesVal = document.getElementById('story-likes-val');
    if (bylineLikesVal) {
        bylineLikesVal.innerText = `${count} lượt thích`;
    }

    // 3. Update any visible card in the DOM
    const cardEl = document.querySelector(`.article-card[data-article-id="${artId}"]`);
    if (cardEl) {
        const cardLikeBtn = cardEl.querySelector('[data-like-btn]');
        if (cardLikeBtn) {
            cardLikeBtn.classList.toggle('liked', isLiked);
            const cardIcon = cardLikeBtn.querySelector('.material-symbols-rounded');
            const cardCounter = cardLikeBtn.querySelector('.like-counter');
            if (cardIcon) cardIcon.innerText = isLiked ? 'favorite' : 'favorite_border';
            if (cardCounter) cardCounter.innerText = count;
        }
    }
}

/**
 * Ensure currentStoryArticle is never null when an action is performed
 */
export function ensureCurrentStoryArticle() {
    if (!currentStoryArticle) {
        const found = findArticleData(101);
        if (found.article) {
            currentStoryArticle = { ...found.article };
        } else {
            const titleEl = document.getElementById('story-title-el');
            const sapoEl = document.getElementById('story-sapo-text');
            currentStoryArticle = {
                id: 101,
                title: (titleEl && titleEl.innerText) || 'Hồi phục thần kỳ sau 10 năm liệt giường nhờ thực hành thiền định',
                desc: (sapoEl && sapoEl.innerText) || 'Một câu chuyện có thật được các bác sĩ và gia đình chứng kiến về sự kỳ diệu của sinh mệnh khi quay về với bản tính thiện lương.',
                tag: 'Khỏi bệnh thần kỳ',
                duration: '',
                img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=600&q=80'
            };
        }
    }
    return currentStoryArticle;
}

/**
 * Handle Story Like Toggle with pulse animation and feedback
 */
export function handleStoryLikeToggle(e) {
    if (e) {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.stopPropagation === 'function') e.stopPropagation();
    }
    const art = ensureCurrentStoryArticle();
    const artId = Number(art.id) || art.id || 101;

    let likes = [];
    try {
        const raw = JSON.parse(localStorage.getItem('dieukydieu_likes') || '[]');
        likes = raw.map(x => (typeof x === 'number' ? x : Number(x) || x));
    } catch (err) {
        likes = [];
    }

    const wasLiked = likes.includes(artId) || likes.includes(art.id);
    if (wasLiked) {
        likes = likes.filter(id => id !== artId && id !== art.id);
        showToast(t('toast_unliked') || 'Đã bỏ thích bài viết');
    } else {
        likes.push(artId);
        showToast(`Đã thả tim bài viết ❤️ (${getArticleLikes(artId)} lượt thích)`);
    }

    localStorage.setItem('dieukydieu_likes', JSON.stringify(likes));
    updateAllStoryLikeButtons(artId);
    if (typeof window !== 'undefined' && typeof window.updateSidebarFavoritesBadge === 'function') {
        window.updateSidebarFavoritesBadge();
    }

    // Trigger pulse on top and bottom like buttons
    const topBtn = document.getElementById('story-top-like-btn');
    const bottomBtn = document.getElementById('story-bottom-like-btn');
    [topBtn, bottomBtn].forEach(b => {
        if (b) {
            b.classList.add('heart-pulse');
            setTimeout(() => b.classList.remove('heart-pulse'), 600);
        }
    });
}

/**
 * Open Story Share action
 */
export function openStoryShare(e) {
    if (e) {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.stopPropagation === 'function') e.stopPropagation();
    }
    const art = ensureCurrentStoryArticle();
    const title = art.title || (document.getElementById('story-title-el')?.innerText) || 'dieukydieu.tv';
    openShareAction(title, window.location.href, e);
}

/**
 * Share to Specific Channel (Facebook, Zalo)
 */
export function shareStoryToChannel(channel) {
    const art = ensureCurrentStoryArticle();
    const title = encodeURIComponent(art.title || document.getElementById('story-title-el')?.innerText || 'dieukydieu.tv');
    const url = encodeURIComponent(window.location.href);

    if (channel === 'facebook') {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank', 'noopener,noreferrer,width=600,height=500');
    } else if (channel === 'zalo') {
        window.open(`https://zalo.me/share?url=${url}`, '_blank', 'noopener,noreferrer,width=600,height=500');
    }
}

/**
 * Copy Current Story URL
 */
export function copyStoryLink() {
    const url = window.location.href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
            showToast('Đã sao chép liên kết bài viết! 📋');
        }).catch(() => {
            fallbackCopyText(url);
        });
    } else {
        fallbackCopyText(url);
    }
}

function fallbackCopyText(text) {
    const input = document.createElement('textarea');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    try {
        document.execCommand('copy');
        showToast('Đã sao chép liên kết bài viết! 📋');
    } catch (e) {
        showToast('Không thể sao chép liên kết');
    }
    document.body.removeChild(input);
}

/**
 * Open QR Code modal on Desktop
 */
export function openStoryQrCode() {
    const art = ensureCurrentStoryArticle();
    const title = art.title || (document.getElementById('story-title-el')?.innerText) || 'dieukydieu.tv';
    openShareModalDesktop(title, window.location.href);
}

/**
 * See more articles in this category
 */
export function seeMoreCategoryStories() {
    const art = ensureCurrentStoryArticle();
    const found = findArticleData(art, art.id);
    if (found.category && found.category.slug && typeof window.openCategoryBySlug === 'function') {
        window.openCategoryBySlug(found.category.slug);
    } else {
        navigateToView('category-view');
    }
}

/**
 * Bind event listeners to story action buttons
 */

export function changeStoryFontSize(delta) {
    currentFontSizeLevel += delta;
    if (currentFontSizeLevel < -1) currentFontSizeLevel = -1;
    if (currentFontSizeLevel > 2) currentFontSizeLevel = 2;
    applyStoryFontSize();
    try {
        localStorage.setItem('dieukydieu_font_level', currentFontSizeLevel.toString());
    } catch (e) {}

    const labels = {
        '-1': 'Cỡ chữ: Nhỏ (15px)',
        '0': 'Cỡ chữ: Mặc định (17px)',
        '1': 'Cỡ chữ: Lớn (19px)',
        '2': 'Cỡ chữ: Rất lớn (21px)'
    };
    if (typeof showToast === 'function') {
        showToast(labels[currentFontSizeLevel.toString()] || 'Đã đổi cỡ chữ');
    }
}

export function resetStoryFontSize() {
    currentFontSizeLevel = 0;
    applyStoryFontSize();
    try {
        localStorage.setItem('dieukydieu_font_level', '0');
    } catch (e) {}
    if (typeof showToast === 'function') {
        showToast('Cỡ chữ: Mặc định (17px)');
    }
}

export function applyStoryFontSize() {
    const bodyEl = document.getElementById('story-body-el');
    const sapoEl = document.getElementById('story-sapo-el');
    const idx = currentFontSizeLevel + 1; // 0 to 3
    const size = FONT_SIZES[idx] || '17px';
    if (bodyEl) {
        bodyEl.style.fontSize = size;
    }
    if (sapoEl) {
        sapoEl.style.fontSize = `calc(${size} + 1px)`;
    }
    const authorEl = document.getElementById('story-author-signature');
    if (authorEl) {
        authorEl.style.fontSize = size;
    }

    // Update active state on font buttons
    const fontDec = document.getElementById('font-decrease-btn');
    const fontRes = document.getElementById('font-reset-btn');
    const fontInc = document.getElementById('font-increase-btn');
    if (fontDec) fontDec.classList.toggle('active', currentFontSizeLevel === -1);
    if (fontRes) fontRes.classList.toggle('active', currentFontSizeLevel === 0);
    if (fontInc) fontInc.classList.toggle('active', currentFontSizeLevel > 0);

    if (typeof window !== 'undefined' && typeof window.updateReaderPopoverUI === 'function') {
        window.updateReaderPopoverUI(currentFontSizeLevel);
    }
}

/**
 * Initialize Story Module
 */

export function scrollToStoryTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}
